
export class ArrayQueue<T>{
  array : (T|undefined)[] = []
  /**
   * Add an object at the first undefined place or at the end
   * @param object 
   * @returns the index where it has been pushed in the array
   */
  push(object : T) :number{
    var emptyIndex = this.array.indexOf(undefined);
    if(emptyIndex===-1) emptyIndex = this.array.length;
    this.array[emptyIndex] = object;
    return emptyIndex; 
  }
  /**
   * Remove an object
   * @param object 
   * @returns the index where it was
   */
  remove(object : T) :number{
    var index = this.array.indexOf(object);
    if(index!==-1){
      this.array[index] = undefined;
    }
    return index;
  }

}